export default "__VITE_ASSET__GGWQvPnc__"